/* ============================================================
   IDEAS CAFE — <ideas-scroller>

   Arrow controls for any horizontally scrolling track.

     <ideas-scroller>
       <button data-scroll-prev>…</button>
       <button data-scroll-next>…</button>
       <div data-scroll-track>…cards…</div>
     </ideas-scroller>

   Generic on purpose: the related-products band fetches its own markup
   and owns its arrows, but every other scrolling row on the site is
   rendered server-side and only needs this. Scrolling itself is native
   overflow — this adds the desktop affordance, nothing more.
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('ideas-scroller')) return;

  class IdeasScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroll-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[data-scroll-prev]');
      this.next = this.querySelector('[data-scroll-next]');

      this._onClick = this._onClick.bind(this);
      this._update = this._update.bind(this);

      this.addEventListener('click', this._onClick);
      this.track.addEventListener('scroll', this._update, { passive: true });
      window.addEventListener('resize', this._update, { passive: true });

      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._update);
    }

    _onClick(event) {
      var back = event.target.closest('[data-scroll-prev]');
      var fwd = event.target.closest('[data-scroll-next]');
      if (!back && !fwd) return;

      event.preventDefault();

      // A card plus its gap, so a press lands on a card edge rather than
      // an arbitrary offset. The first *visible* card — a filtered track
      // (e.g. the partners tabs) can start with a hidden one, which
      // measures 0 wide and would leave the arrows moving by the gap alone.
      var card = Array.prototype.find.call(this.track.children, function (el) {
        return el.offsetWidth > 0;
      });
      var step = this.track.clientWidth;
      if (this.hasAttribute('data-scroll-page')) {
        // Rows of small, uneven items (filter pills): one press moves
        // most of a screen rather than a single narrow item.
        step = Math.round(this.track.clientWidth * 0.8);
      } else if (card) {
        var styles = window.getComputedStyle(this.track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        step = card.offsetWidth + gap;
      }

      this.track.scrollBy({ left: back ? -step : step, behavior: 'smooth' });
    }

    // Disabled at the end of travel, rather than left as a control that
    // silently does nothing.
    _update() {
      if (!this.prev || !this.next) return;

      var max = this.track.scrollWidth - this.track.clientWidth;

      // Nothing overflows, so there is nowhere to scroll.
      if (max <= 1) {
        this.prev.disabled = true;
        this.next.disabled = true;
        return;
      }

      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  customElements.define('ideas-scroller', IdeasScroller);
})();
